import React from 'react'
import { Navigate, useLocation } from 'react-router-dom'
import { useAuth } from '../Contexts/AuthContext'

const RequireAuth = ({ children }) => {
  const { authData } = useAuth();
  const location = useLocation();

  const isLoggedIn = !!authData.accessToken;

  if (!isLoggedIn) {
    return <Navigate to={`/login?next=${encodeURIComponent(location.pathname + location.search)}`} />
  }

  return children;
}

export default RequireAuth;
